import { INCREMENT_CENTS, MAX_PRESS_AMOUNT_CENTS } from "./constants";

export function isWholeDollarAmount(amountCents: number): boolean {
  return Number.isSafeInteger(amountCents) && amountCents % 100 === 0;
}

export function validateSelectedAmount(
  selectedAmountCents: number,
  minimumPriceCents: number,
  maximumAmountCents = MAX_PRESS_AMOUNT_CENTS,
): boolean {
  return (
    isWholeDollarAmount(selectedAmountCents) &&
    selectedAmountCents >= minimumPriceCents &&
    selectedAmountCents <= maximumAmountCents
  );
}

export function nextMinimumFromCaptured(
  capturedSubtotalCents: number,
  incrementCents = INCREMENT_CENTS,
): number {
  if (!isWholeDollarAmount(capturedSubtotalCents)) {
    throw new TypeError("Captured subtotal must be a whole-dollar amount in cents.");
  }
  if (!Number.isSafeInteger(incrementCents) || incrementCents <= 0) {
    throw new TypeError("Increment must be a positive integer in cents.");
  }
  const next = capturedSubtotalCents + incrementCents;
  if (!Number.isSafeInteger(next)) {
    throw new RangeError("Next minimum exceeds the safe integer range.");
  }
  return next;
}

export function formatUsd(amountCents: number): string {
  if (!Number.isSafeInteger(amountCents)) {
    throw new TypeError("Amount must be an integer in cents.");
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: amountCents % 100 === 0 ? 0 : 2,
  }).format(amountCents / 100);
}
